import { render, staticRenderFns } from "./AccountSpeciesGroups.vue?vue&type=template&id=1f1354e4&"
import script from "./AccountSpeciesGroups.vue?vue&type=script&lang=js&"
export * from "./AccountSpeciesGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports